import { render, staticRenderFns } from "./AuditStatusNewsComment.vue?vue&type=template&id=95905c8a&"
import script from "./AuditStatusNewsComment.vue?vue&type=script&lang=js&"
export * from "./AuditStatusNewsComment.vue?vue&type=script&lang=js&"
import style0 from "./AuditStatusNewsComment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports